import axios from "./axios";
import { NINJA_3_ENDPOINT } from "./endpoint";
export const GetIcons = () => {
  return axios.get(
    `${NINJA_3_ENDPOINT}/api/images/?is_default=1&image_type_id=1`
  );
};
